import React from 'react'
import classes from './PharmaciesLeading.module.css'
import { appPath } from '@/lib/getPublicAppUrl'

const PHARMACY_LOGOS = [
    { src: appPath('/assets/pharmacy/cvs-logo.svg'), alt: '' },
    { src: appPath('/assets/pharmacy/walgreens-logo.svg'), alt: '' },
    { src: appPath('/assets/pharmacy/walmart-logo.svg'), alt: '' },
] as const

/** Circular CVS / Walgreens / Walmart stack for medication featured cards. */
export default function PharmaciesLeading() {
    return (
        <div className={classes.stack} aria-hidden>
            {PHARMACY_LOGOS.map((logo) => (
                <span key={logo.src} className={classes.circle}>
                    {/* eslint-disable-next-line @next/next/no-img-element -- fixed-size circular overlap stack */}
                    <img
                        src={logo.src}
                        alt={logo.alt}
                        width={24}
                        height={24}
                        className={classes.image}
                        decoding="async"
                    />
                </span>
            ))}
        </div>
    )
}
